import merge from 'lodash/merge';

export const encodeObject = <T extends Record<string, unknown>>(object: T) => {
  const isEncoding = true;
  return transformObject(object, isEncoding);
};

export const decodeObject = <T extends Record<string, unknown>>(object: T) => {
  const isEncoding = false;
  return transformObject(object, isEncoding);
};

export const encodeString = (input: string) =>
  window.btoa(encodeUnicode(input));

export const decodeString = (input: string) =>
  decodeUnicode(window.atob(input));

const transformObject = <T extends Record<string, unknown>>(
  object: T,
  isEncoding: boolean,
) => {
  const toEntry = (
    obj: Record<string, unknown>,
    key: string,
  ): [string, unknown] => [key, obj[key]];
  const transformEntries = (key: string): Record<string, unknown> =>
    transformEntry(toEntry(object, key), isEncoding);
  const transformedObject = Object.keys(object).map(transformEntries);

  return merge({}, ...transformedObject);
};

const transformEntry = (entry: [string, any], isEncoding: boolean) => {
  const [name, value] = entry;
  const isString = value && typeof value === 'string';
  const isObject = value && typeof value === 'object';

  let operation = (value: any) => value;
  if (isObject) {
    operation = isEncoding ? encodeObject : decodeObject;
  }
  if (isString) {
    operation = isEncoding ? encodeString : decodeString;
  }

  return { [name]: operation(value) };
};

const decodeUnicode = (str: string) =>
  decodeURIComponent(
    str
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );

const toSolidBytes = (_match: string, p1: string): string =>
  String.fromCharCode(parseInt(p1, 16));

const encodeUnicode = (str: string) =>
  encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, toSolidBytes);
